import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairporttomaheshwarcab() {



const cardData = {
  keyword: " Mumbai Airport to Mahabaleshwar Cab",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai Airport to Mahabaleshwar cab services, ensuring a smooth and scenic journey for family trips, group outings, corporate travel, and leisure tours. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Mumbai Airport to Mahabaleshwar convenient and stress-free. The journey covers approximately 240–260 km via the Mumbai–Pune Expressway and NH48, typically taking around 5–6 hours depending on traffic and road conditions. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai Airport to Mahabaleshwar cab travel.",

topPlaces: [
  {
    title: "Venna Lake",
    description: "Venna Lake is a popular tourist attraction in Mahabaleshwar, known for its serene waters and boating opportunities. Travelers from Mumbai Airport can enjoy paddle boating, horse riding along the lake, and relaxing in the surrounding gardens. The cab ensures a comfortable journey through the scenic Western Ghats."
  },
  {
    title: "Pratapgad Fort",
    description: "Pratapgad Fort is a historic hill fort near Mahabaleshwar offering panoramic views of the Sahyadri mountains. Visitors traveling by cab can explore the fort's architecture, learn about its historical significance, and enjoy trekking trails leading to breathtaking viewpoints."
  },
  {
    title: "Mapro Garden",
    description: "Mapro Garden is famous for its strawberry plantations, fresh juices, and delicious snacks. Travelers from Mumbai Airport can enjoy a guided visit, taste strawberry products, and shop for jams and chocolates while relaxing in a lush garden setting."
  },
  {
    title: "Arthur’s Seat",
    description: "Arthur’s Seat is a renowned viewpoint in Mahabaleshwar offering stunning vistas of the valleys and surrounding hills. Visitors traveling by cab can enjoy panoramic photography, serene moments, and the cool climate at this popular destination."
  },
  {
    title: "Elephant’s Head Point",
    description: "Elephant’s Head Point is a scenic cliff resembling an elephant’s head, providing spectacular views of the Krishna Valley. Travelers arriving from Mumbai Airport by cab can enjoy nature walks, photography, and the tranquility of the Western Ghats."
  },
  {
    title: "Lingmala Waterfall",
    description: "Lingmala Waterfall is a picturesque waterfall near Mahabaleshwar, ideal for sightseeing and nature photography. Visitors can take a cab from Mumbai Airport to explore the waterfall, enjoy the lush greenery, and relax amidst the peaceful surroundings."
  },
  {
    title: "Wilson Point",
    description: "Wilson Point, also known as Sunrise Point, offers breathtaking sunrise views over Mahabaleshwar. Travelers from Mumbai Airport can reach this viewpoint easily by cab and enjoy early morning photography, fresh air, and panoramic hill views."
  },
  {
    title: "Connaught Peak",
    description: "Connaught Peak is one of the highest points in Mahabaleshwar, offering sweeping views of the valley and surrounding landscapes. Visitors traveling by cab can enjoy trekking, sightseeing, and capturing scenic photographs of the Western Ghats."
  },
  {
    title: "Kate’s Point",
    description: "Kate’s Point provides stunning views of the Dhom Dam and Krishna Valley. Travelers arriving from Mumbai Airport can enjoy the serene atmosphere, take photographs, and relax at this popular Mahabaleshwar viewpoint."
  },
  {
    title: "Panchgani Table Land",
    description: "Panchgani Table Land is a vast plateau near Mahabaleshwar offering panoramic views, horse riding, and nature walks. Travelers from Mumbai Airport can explore this unique landscape by cab, enjoy the cool climate, and experience adventure activities in a scenic environment."
  }
],



services: [
{
name: "Mumbai Airport to Mahabaleshwar Cab",
description: "Mumbai Airport to Mahabaleshwar cab service offers a comfortable and scenic hill station journey for travelers arriving at the airport and heading towards Mahabaleshwar. This route is popular for its lush green valleys, winding ghats, and breathtaking viewpoints, making the road trip enjoyable and refreshing. The service is ideal for families, couples, tourists, and corporate travelers looking for a private and hassle-free transfer directly from the airport. Drivers track flight timings to ensure timely pickup from Terminal 1 and Terminal 2 without waiting delays. Travelers can choose from a wide range of vehicles including sedan, SUV, and premium options depending on group size and comfort preference. Doorstep drop at hotels, resorts, and homestays in Mahabaleshwar ensures complete convenience. With transparent pricing, flexible travel options, and 24x7 booking availability, this cab service guarantees a smooth and memorable travel experience."
},
{
name: "Mumbai Airport to Mahabaleshwar Taxi",
description: "Mumbai Airport to Mahabaleshwar taxi service provides reliable and comfortable transportation for long-distance travel with well-maintained vehicles and experienced drivers. This service is perfect for travelers who prefer a direct and private journey to the hill station. Spacious seating and clean interiors ensure comfort during the entire trip. Drivers are experienced in driving through ghat roads, ensuring safety and smooth navigation. Multiple vehicle options including sedan and SUV are available for different travel needs. Flexible pickup from airport terminals adds convenience. It ensures a safe and enjoyable journey."
},
{
name: "One Way Cab Mumbai Airport to Mahabaleshwar",
description: "One way cab Mumbai Airport to Mahabaleshwar is a cost-effective option for travelers who need a single-side drop without paying for return charges. This service is ideal for tourists planning extended stays in Mahabaleshwar. Customers benefit from competitive pricing, flexible pickup timing, and easy booking options. Professional drivers ensure safe driving across highways and hilly terrains. Sedan and SUV options are available based on comfort preferences. Instant online booking ensures quick confirmation. It is a convenient and budget-friendly travel solution."
},
{
name: "Mumbai Airport to Mahabaleshwar Cab Booking",
description: "Mumbai Airport to Mahabaleshwar cab booking allows customers to reserve their ride easily with instant confirmation and flexible scheduling. Travelers can select vehicle type, pickup time, and drop location according to their requirements. Transparent pricing ensures there are no hidden charges during the journey. Online booking platforms offer secure payment options and real-time availability. Dedicated customer support is available for assistance at any stage. This service ensures a smooth and organized travel experience. It is the most convenient way to plan your hill station trip."
},
{
name: "Mumbai Airport to Mahabaleshwar Taxi Fare",
description: "Mumbai Airport to Mahabaleshwar taxi fare is designed to be transparent and budget-friendly, helping travelers plan their trip efficiently. Pricing depends on vehicle type, travel distance, and trip duration. Customers receive a clear breakdown of costs including tolls and driver allowances where applicable. Affordable options are available for sedan, SUV, and premium vehicles. No hidden charges ensure trust and reliability. Flexible pricing options suit different budgets. It offers excellent value for long-distance hill travel."
},
{
name: "Cheap Cab Mumbai Airport to Mahabaleshwar",
description: "Cheap cab Mumbai Airport to Mahabaleshwar offers budget-friendly travel options without compromising on comfort and safety. This service is ideal for travelers looking for economical transportation to a hill station destination. Sedan vehicles provide cost-effective travel solutions with transparent pricing. Professional drivers ensure safe and smooth travel across highways and ghats. Flexible booking options make it easy to plan your journey. It is a perfect choice for budget-conscious travelers. It combines affordability with reliability."
},
{
name: "Mumbai Airport to Mahabaleshwar Outstation Cab",
description: "Mumbai Airport to Mahabaleshwar outstation cab service provides reliable travel solutions for intercity journeys with comfort and safety. This service is suitable for tourists, families, and corporate travelers. Vehicles are well-maintained for long-distance and hill road travel. Flexible options include one way and round trip packages. Professional drivers ensure safe navigation through ghat sections. Pickup directly from airport terminals adds convenience. It ensures a hassle-free and enjoyable journey experience."
},
{
name: "Mumbai Airport to Mahabaleshwar SUV Taxi",
description: "Mumbai Airport to Mahabaleshwar SUV taxi is ideal for travelers who need extra space, comfort, and power for hill station travel. SUVs provide better road grip and spacious seating, making them perfect for ghat roads and long-distance journeys. This option is suitable for families, groups, and corporate travelers. Professional drivers ensure safe driving in hilly terrains. It offers a premium and comfortable travel experience. Perfect for extended road trips. It ensures a smooth and enjoyable ride."
},
{
name: "Mumbai Airport to Mahabaleshwar Sedan Cab",
description: "Mumbai Airport to Mahabaleshwar sedan cab is a popular choice for couples and small families seeking a comfortable yet budget-friendly ride. Sedans offer smooth travel, good mileage, and comfortable seating for long journeys. This service is ideal for economical travel without compromising convenience. Professional drivers ensure safe and efficient driving. Flexible pickup options enhance convenience. It is one of the most preferred travel options. It ensures a pleasant journey experience."
},
{
name: "Private Cab Mumbai Airport to Mahabaleshwar",
description: "Private cab Mumbai Airport to Mahabaleshwar offers a personalized travel experience with exclusive vehicle usage for families and groups. Travelers can customize routes, stops, and travel schedules according to their preferences. This ensures a relaxed and stress-free journey. Professional drivers provide safe and reliable service with complete privacy. Comfortable seating and premium service enhance the experience. It is ideal for private and luxury travel. It guarantees flexibility and comfort."
},
{
name: "AC Taxi Mumbai Airport to Mahabaleshwar",
description: "AC taxi Mumbai Airport to Mahabaleshwar ensures a comfortable journey in air-conditioned vehicles for long-distance and hill travel. This service provides a cool and pleasant environment during the entire journey. Clean interiors and well-maintained AC systems enhance passenger comfort. Suitable for families, tourists, and business travelers. Flexible booking options make travel planning easy. Professional drivers ensure timely service. It guarantees a relaxing and enjoyable travel experience."
},
{
name: "Book Mumbai Airport to Mahabaleshwar Cab Online",
description: "Book Mumbai Airport to Mahabaleshwar cab online for quick and hassle-free reservations with instant confirmation. Customers can easily select vehicle type, pickup time, and drop location through online platforms. Secure payment options and transparent pricing make booking convenient. This service ensures vehicle availability even during peak seasons. Dedicated support is available for assistance anytime. It simplifies travel planning for hill station trips. It is the most efficient and convenient booking option."
}
],

tableData: [
["Mumbai Airport to Mahabaleshwar Cab","Mumbai Airport to Mahabaleshwar Taxi"],
["One Way Cab Mumbai Airport to Mahabaleshwar","Mumbai Airport to Mahabaleshwar Cab Booking"],
["Mumbai Airport to Mahabaleshwar Taxi Fare","Cheap Cab Mumbai Airport to Mahabaleshwar"],
["Mumbai Airport to Mahabaleshwar Outstation Cab","Mumbai Airport to Mahabaleshwar SUV Taxi"],
["Mumbai Airport to Mahabaleshwar Sedan Cab","Private Cab Mumbai Airport to Mahabaleshwar"],
["AC Taxi Mumbai Airport to Mahabaleshwar","Book Mumbai Airport to Mahabaleshwar Cab Online"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Hill Station Transfer",
    WhyChoosedescription: "Velocity Cabs offers reliable Mumbai Airport to Mahabaleshwar cab service for a smooth and scenic journey, perfect for family vacations, couples, and weekend getaways."
  },
  {
    WhyChooseheading: "Experienced Ghat Section Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in driving through ghat roads and hill station routes to Mahabaleshwar, ensuring safe navigation and a comfortable travel experience."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Mumbai Airport to Mahabaleshwar cab bookings. Customers receive complete fare details including toll charges and driver allowance."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Our Mumbai Airport to Mahabaleshwar cab service operates 24/7. Whether your flight arrives early morning or late night, we ensure reliable pickup and drop service."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a relaxing long-distance and hill travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, and customized Mahabaleshwar tour packages."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, and group travel."
  },
  {
    WhyChooseheading: "Trusted Hill Station Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai Airport to Mahabaleshwar cab bookings due to punctual drivers, clean vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai Airport to Mahabaleshwar cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Mumbai Airport to Mahabaleshwar for one-way and round-trip travel." },
  { question: "How far is Mahabaleshwar from Mumbai Airport?", answer: "The distance between Mumbai Airport and Mahabaleshwar is approximately 260 to 280 km and travel time is around 6 to 7 hours depending on traffic and ghat conditions." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai Airport to Mahabaleshwar cab service operates 24/7." },
  { question: "Which terminals are covered?", answer: "We provide pickup from all terminals including Terminal 1 and Terminal 2 of Mumbai Airport." },
  { question: "Which vehicles are available for this route?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mumbai Airport to Mahabaleshwar cabs online or through phone booking." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Patil",
    feedback:
      "The Mumbai Airport to Mahabaleshwar cab ride was very comfortable and well-managed. The driver was punctual, and the long journey felt smooth and relaxing throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Deshmukh",
    feedback:
      "Traveling from Mumbai Airport to Mahabaleshwar was a great experience. The cab was clean, the ride was steady, and everything was handled very professionally.",
    rating: 5
  }
];






















const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const mumbaiAirportMahabaleshwarCabJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai Airport to Mahabaleshwar Cab Service | Velocity Cabs",
  "description": "Book a private cab from Mumbai Airport to Mahabaleshwar for comfortable outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mumbai Airport to Mahabaleshwar Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Mumbai Airport to Mahabaleshwar",
        "description": "Private cab from Mumbai Airport to Mahabaleshwar for one-way travel with AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Mumbai Airport to Mahabaleshwar Cab",
        "description": "Comfortable round-trip cab service from Mumbai Airport to Mahabaleshwar with private AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};




  return (
    <div>
      

<Helmet>
  <title>Mumbai Airport to Mahabaleshwar Cab Service | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Mumbai Airport to Mahabaleshwar for comfortable outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiAirportMahabaleshwarCabJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/95.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairporttomaheshwarcab;